<template>
  <div class="flex right_card">
    <div class="md-card md-card-tabs">
      <div class="md-card-header font_bold">{{$t('dashboard.Receivables.Sold')}}</div>
      <div class="card_content font_bold">{{salesSummary.soldCount}}</div>
    </div>
    <div class="md-card md-card-tabs">
      <div class="md-card-header font_bold">{{$t('dashboard.Receivables.soldVolume')}}</div>
      <div class="card_content font_bold">
        <span>{{millionFormat(salesSummary.totalSoldVolume) }}</span>
        <i v-if="isMillion(salesSummary.totalSoldVolume)">m</i>
      </div>
    </div>
    <div class="md-card md-card-tabs">
      <div class="md-card-header font_bold">{{$t('dashboard.Sales.netPayoutVolume')}}</div>
      <div class="card_content font_bold">
        <span>{{millionFormat(salesSummary.totalNetPayoutVolume) }}</span>
        <i v-if="isMillion(salesSummary.totalNetPayoutVolume)">m</i>
      </div>
    </div>
    <div class="md-card md-card-tabs">
      <div class="md-card-header font_bold">
        <span>{{$t('dashboard.Advanced.day')}}</span>
      </div>
      <div class="card_content font_bold">
        <FieldWithUnit :value="salesSummary.avgAdvancedDays" :unit="$t('common.day.short')"></FieldWithUnit>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {formatAsDecimal} from "@/common/format";
import FieldWithUnit from "@/views/dashboard/FieldWithUnit";

export default {
  data() {
    return {
      defaultSalesSummary: {
        soldCount: 0,
	    totalSoldVolume: "",
        totalNetPayoutVolume: "",
        avgAdvancedDays: null
      },
      salesSummary: {
        ...this.defaultSalesSummary
      }
    };
  },
  components: {
    FieldWithUnit
  },
  computed: {
    ...mapGetters({ dashboardInfo: "dashboardInfo" })
  },
  watch: {
    dashboardInfo() {
      let { statisticData } = this.dashboardInfo;
      if (statisticData && statisticData.salesSummary) {
        this.salesSummary = {
          ...statisticData.salesSummary,
          soldCount: formatAsDecimal(statisticData.salesSummary.soldCount, {decimals: 0}),
          avgAdvancedDays: formatAsDecimal(statisticData.salesSummary.avgAdvancedDays, {decimals: 0})
        };
      } else {
        this.salesSummary = this.defaultSalesSummary
      }
    }
  }
};
</script>